import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

type Upcoming = {
  id: number;
  event: number;
  kickoff_time: string;
  team_h: number;
  team_a: number;
  eafd_h: number;
  eafd_a: number;
};

export default function Team(): React.JSX.Element {
  const { id } = useParams();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const controller = new AbortController();
    async function load() {
      try {
        const res = await fetch(`/api/team/${id}`, { signal: controller.signal });
        setData(await res.json());
      } finally {
        setLoading(false);
      }
    }
    if (id) load();
    return () => controller.abort();
  }, [id]);

  const spark = useMemo(() => {
    const points: Array<{ gw: number; elo: number }> = data?.elo_trend ?? [];
    if (!points.length) return null;
    const width = 320;
    const height = 60;
    const min = Math.min(...points.map(p => p.elo));
    const max = Math.max(...points.map(p => p.elo));
    const x = (i: number) => (i / Math.max(1, points.length - 1)) * width;
    const y = (elo: number) => height - ((elo - min) / Math.max(1, max - min)) * height;
    const d = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${x(i).toFixed(1)} ${y(p.elo).toFixed(1)}`).join(' ');
    return (
      <svg width={width} height={height} style={{ display: 'block', background: '#fafbfc', borderRadius: 4 }}>
        <path d={d} stroke="#2563eb" strokeWidth={2} fill="none" />
      </svg>
    );
  }, [data]);

  if (loading) return <p>Loading...</p>;
  if (!data) return <p>Not found</p>;

  const upcoming: Upcoming[] = data.upcoming ?? [];

  return (
    <div>
      <h2>{data.team?.name}</h2>
      {spark}
      <h3 style={{ marginTop: 16 }}>Upcoming fixtures</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th align="left">GW</th>
            <th align="left">Fixture</th>
            <th align="right">EAFD (H)</th>
            <th align="right">EAFD (A)</th>
          </tr>
        </thead>
        <tbody>
          {upcoming.map(f => (
            <tr key={f.id}>
              <td>GW{f.event}</td>
              <td>{f.team_h} vs {f.team_a}</td>
              <td align="right">{f.eafd_h.toFixed(2)}</td>
              <td align="right">{f.eafd_a.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <pre style={{ background: '#f6f8fa', padding: 12, overflow: 'auto' }}>{JSON.stringify({ elo_trend: data.elo_trend?.slice(-5), upcoming: data.upcoming?.length }, null, 2)}</pre>
    </div>
  );
}


